module.exports = __webpack_public_path__ + "img/2-6.6f7ad86b.png";